/* N1 · Botón minimalista de pantalla completa en los vídeos (home y fichas).
   Además, en móvil: al deslizar la galería del producto hasta un vídeo, intenta abrirlo a pantalla completa. */
(function(){
if(window.N1VidFS)return;window.N1VidFS=1;
var css=''
+'.n1-fsbtn{position:absolute;right:.9rem;bottom:4.2rem;z-index:3;width:44px;height:44px;border-radius:50%;border:1px solid rgba(255,255,255,.35);background:rgba(8,8,8,.55);color:#fff;cursor:pointer;display:grid;place-items:center;backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);transition:border-color .2s,transform .2s}'
+'.n1-fsbtn:hover{border-color:#e4ee05;color:#e4ee05;transform:scale(1.06)}'
+'.n1-fsbtn svg{width:17px;height:17px;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}'
+'.n1-fsbtn--alone{bottom:.9rem}';
var st=document.createElement('style');st.textContent=css;(document.head||document.documentElement).appendChild(st);
var ICON='<svg viewBox="0 0 24 24"><path d="M15 3h6v6"/><path d="M9 21H3v-6"/><path d="M21 3l-7 7"/><path d="M3 21l7-7"/></svg>';
function full(el){
  var v=el.tagName==='VIDEO'?el:el.querySelector('video');
  if(document.fullscreenElement||document.webkitFullscreenElement){
    (document.exitFullscreen||document.webkitExitFullscreen).call(document);return;
  }
  var t=v||el;
  var fn=t.requestFullscreen||t.webkitRequestFullscreen||t.msRequestFullscreen;
  if(v&&v.webkitEnterFullscreen&&!document.fullscreenEnabled){try{v.webkitEnterFullscreen();return}catch(e){}}
  if(fn){try{fn.call(t)}catch(e){if(v&&v.webkitEnterFullscreen)v.webkitEnterFullscreen()}}
  else if(v&&v.webkitEnterFullscreen){v.webkitEnterFullscreen()}
}
function add(){
  document.querySelectorAll('.n1v-box, .n1-pvideo .v').forEach(function(box){
    if(box.dataset.n1fs)return;
    if(!box.querySelector('video'))return;
    box.dataset.n1fs='1';
    var b=document.createElement('button');
    b.type='button';b.className='n1-fsbtn'+(box.querySelector('.n1v-sound,.snd')?'':' n1-fsbtn--alone');
    b.setAttribute('aria-label','Pantalla completa');b.innerHTML=ICON;
    b.addEventListener('click',function(e){e.stopPropagation();full(box)});
    box.appendChild(b);
  });
}
/* galería del producto: al llegar al vídeo deslizando, abrirlo a pantalla completa (móvil) */
var touched=false;
['pointerdown','touchstart','keydown'].forEach(function(ev){
  document.addEventListener(ev,function(){touched=true},true);
});
function watchGallery(){
  if(innerWidth>749)return;
  document.querySelectorAll('product-gallery .product-gallery__media[data-media-type="video"], .product-gallery__carousel [data-media-type="video"]').forEach(function(cell){
    if(cell.dataset.n1gfs)return;cell.dataset.n1gfs='1';
    if(!('IntersectionObserver' in window))return;
    new IntersectionObserver(function(es){es.forEach(function(x){
      if(!x.isIntersecting||!touched)return;
      var v=cell.querySelector('video');if(!v)return;
      if(cell.dataset.n1shown)return;cell.dataset.n1shown='1';
      setTimeout(function(){try{full(v)}catch(e){}},220);
    })},{threshold:.9}).observe(cell);
  });
}
function run(){add();watchGallery()}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
addEventListener('load',run);setTimeout(run,1200);setTimeout(run,2600);
new MutationObserver(function(){clearTimeout(window.__n1fs);window.__n1fs=setTimeout(run,400)}).observe(document.body,{childList:true,subtree:true});
})();
